enum LoginErrors {
  MAX_DEVICES = 101,
  MAX_NUM_STBS = 104,
  NO_TOKEN = 111,
  CARRIER_DISABLED = 112,
  USER_DISABLED = 114,
  INACTIVE_USER = 113,
}

export default LoginErrors;
